<!--
    @Author : Luo
    @Time   : 2025/1/17 11:32
-->
<template>
  <div class="inquire">
    <div class="inquire_header">
      <div class="inquire_category">
        <select name="category" id="category" v-model="searchcategoryVal">
          <option v-for="c in cateData" :key="'select-' + c.id"  :value="c.id">{{ c.name }}</option>
        </select>
        <select name="consult" id="consult" v-model="searchconsultVal">
          <option v-for="c in consultData" :key="'consult-' + c.id"  :value="c.id">{{ c.name }}</option>
        </select>
        <!-- <input type="date" name="" id="search-time" v-model="searchTimeVal"> -->
      </div>
      <div class="inquire_search">
        <button @click="getCateQuestion">搜索</button>
      </div>
    </div>
    <div class="inquire_mian">
      <div class="inquire_group">
        <div class="inquire_group_con" v-for="g in quesData" :key="'group-' + g.id">
          <div class="inquire_group_header">
            <div class="inquire_group_header_title"><span>{{ g.name }}</span></div>
          </div>
          <div class="inquire_group_question">
            <div class="inquire_group_question_con" v-for="q in g.data" :key="'group-' + g.id + '-question-' + q.id">
              <elQues :group="g" :data="q" :optionData="sessionQuesOptionData" :cityCompletedData="cityQuesCompleted" :cityData="cityData" />

              <div class="inquire_group_sub_question">
                <div class="inquire_group_sub_question_con" v-for="sub in q.subData" :key="'group-' + g.id + '-question-' + q.id + '-sub-' + sub.id">
                  <elQues :sub="true" :group="g" :data="sub" :optionData="sessionQuesOptionData" :cityCompletedData="cityQuesCompleted" :cityData="cityData" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _Ajax } from '@/api/_axios'
import { resetSpecNum } from '@/components/common/common_js'

import elQues from './el-ques.vue'

const tempSiteName = '后台-调研结果统计系统'

export default {
  name: 'accountAnalysisPage',
  components: {
    elQues
  },
  data () {
    return {
      cateData: [],
      searchcategoryVal: null,
      consultData: [],
      searchconsultVal: null,
      // searchTimeVal: null,
      quesInitalData: [],
      quesData: [],
      groupData: [],
      cityData: {},
      initalCityData: [],
      sessionQuesOptionData: {},
      sessionCateData: [],
      genderQuesInfo: {},
      cityQuesInfo: {},
      cityQuesCompleted: []
    }
  },
  methods: {
    // 获取信息
    getData: async function () {
      const that = this

      try {
        await that.getCitiesData()
        await that.getUserData()
        await that.getCateData()
        await that.getQuesGroupData()
        await that.getCateQuestion()
      } catch (error) {
        console.log('【error:getData】', error)
      }
    },
    // 获取用户
    getUserData: async function () {
      const that = this

      try {
        that.consultData = []
        that.consultData = await that.getApiData('/user/list')
        that.consultData.push({ active: 1, card: '', id: null, name: '全部', role: '' })
        that.searchconsultVal = that.consultData[0].id
      } catch (error) {
        console.log('【error:getUserData', error)
      }
    },
    // 获取问卷
    getCateData: async function () {
      const that = this

      try {
        that.cateData = await that.getApiData('/inquire/category')
        that.searchcategoryVal = that.cateData[0].id
      } catch (error) {
        console.log('【error:getCateData', error)
      }
    },
    // 获取已做问卷
    getSessionCateData: async function () {
      const that = this

      try {
        that.sessionCateData = []
        const resData = await that.getApiData('/session/category')
        for (const item of resData) {
          // 判断是否符合当前筛选的咨询师
          const isComplete = item.isComplete === 1

          // 判断是否符合当前筛选的咨询师
          const isNeedConsult = that.searchconsultVal ? item.userId === that.searchconsultVal : true

          // // 判断是否符合当前筛选的时间
          // const cateTime = new Date(item.createdAt).getTime()
          // const isNeedTime = that.searchTimeVal

          if (isComplete && isNeedConsult) {
            that.sessionCateData.push(item.id)
          }
        }
      } catch (error) {
        console.log('【error:getSessionCateData', error)
      }
    },
    // 获取问题组
    getQuesGroupData: async function () {
      const that = this

      try {
        that.groupData = await that.getApiData('/inquire/group')
      } catch (error) {
        console.log('【error:getQuesGroupData', error)
      }
    },
    // 获取问卷中的所有问题
    getCateQuestion: async function () {
      const that = this

      try {
        that.quesData = []
        that.cityQuesCompleted = []
        await that.getSessionCateData()
        const resQues = await that.getApiData('/inquire/question/category/' + that.searchcategoryVal)
        const tempGenderData = resQues.filter(i => i.content === '性别')
        that.genderQuesInfo = tempGenderData.length > 0 ? tempGenderData[0] : {}
        const tempCityData = resQues.filter(i => i.content && i.content.indexOf('城市') > -1)
        that.cityQuesInfo = tempCityData.length > 0 ? tempCityData[0] : {}
        that.quesInitalData = await that.getCateQuestionOption(resQues)

        that.translateQuesGroupData()
        await that.getSessionOption()

        console.log('所有问题', JSON.parse(JSON.stringify(that.quesInitalData)))
        console.log('问题归类', JSON.parse(JSON.stringify(that.quesData)))
      } catch (error) {
        console.log('【error:getCateQuestion', error)
      }
    },
    // 获取问卷中的问题的选项
    getCateQuestionOption: async function (data) {
      const that = this

      return new Promise(async (resolve, reject) => {
        try {
          const tempData = []

          for await (const item of data) {
            const tempOption = await that.getApiData('/inquire/option/question/' + item.id)
            tempData.push({ ...item, option: tempOption })
          }

          resolve(tempData)
        } catch (error) {
          reject(error)
        }
      })
    },
    // 获取所有客户的统计数据
    getSessionOption: async function () {
      const that = this

      try {
        const tempAnalysisData = {}
        const tempQuesSessionData = {}
        const resQuestion = await that.getApiData('/session/question')
        for (const item of resQuestion) {
          const tempQuesId = item.questionId
          // 判断调研是否完成
          const isSessionCompleted = that.sessionCateData.includes(item.sessionId)

          if (isSessionCompleted) {
            const tempOption = item.option !== null && item.option !== undefined ? item.option.split(',') : []
            if (!tempAnalysisData[tempQuesId]) tempAnalysisData[tempQuesId] = {}

            // 统计选项次数
            for (const optionItem of tempOption) {
              if (!tempAnalysisData[tempQuesId][optionItem]) tempAnalysisData[tempQuesId][optionItem] = 0
              tempAnalysisData[tempQuesId][optionItem] = tempAnalysisData[tempQuesId][optionItem] + 1
            }

            // 统计问题次数
            if (!tempAnalysisData[tempQuesId]['totalQues']) tempAnalysisData[tempQuesId]['totalQues'] = 0
            tempAnalysisData[tempQuesId]['totalQues'] = tempAnalysisData[tempQuesId]['totalQues'] + 1

            // 性别统计
            const genderKey = that.isGenderTotal(item)
            if (genderKey) {
              if (!tempAnalysisData[tempQuesId][genderKey]) tempAnalysisData[tempQuesId][genderKey] = 0
              tempAnalysisData[tempQuesId][genderKey] = tempAnalysisData[tempQuesId][genderKey] + 1
            }

            // 城市需要单独统计
            const cityKey = that.isCityTotal(item)
            if (cityKey) {
              if (!that.cityQuesCompleted.includes(cityKey)) that.cityQuesCompleted.push(cityKey)
              if (!tempAnalysisData[tempQuesId][cityKey]) tempAnalysisData[tempQuesId][cityKey] = 0
              tempAnalysisData[tempQuesId][cityKey] = tempAnalysisData[tempQuesId][cityKey] + 1
            }

            // 以问题为组，便于查看数据分析是否合理
            if (!tempQuesSessionData[tempQuesId]) tempQuesSessionData[tempQuesId] = []
            tempQuesSessionData[tempQuesId].push(item)
          }
        }

        that.sessionQuesOptionData = JSON.parse(JSON.stringify(tempAnalysisData))

        console.log('每个问题的所有已选选项', tempQuesSessionData)
        console.log('城市', JSON.parse(JSON.stringify(that.cityQuesCompleted)), '-', JSON.parse(JSON.stringify(tempAnalysisData)))
      } catch (error) {
        console.log('【error:getSessionOption', error)
      }
    },
    // 获取城市信息
    getCitiesData: async function () {
      try {
        const that = this
        const tempCities = await that.getApiData(`/cities/list`)
        if (tempCities.cities && tempCities.cities.length > 0) {
          for (const item of tempCities.cities) {
            if (!that.cityData[that.getCityKey(item.code)]) that.cityData[that.getCityKey(item.code)] = item.name
            that.initalCityData.push({ ...item })
          }
        }
      } catch (error) {
        console.log('【error:getCitiesData', error)
      }
    },
    // 问题分类
    translateQuesGroupData: function () {
      const that = this
      // 排序
      const tempData = that.quesInitalData.sort((a, b) => a.sort - b.sort)
      const tempQuesData = []

      for (const item of tempData) {
        const tempItem = { ...item }

        // 加入分类
        let tempGroupIdx = tempQuesData.findIndex(i => i.id === that.getGroupId(tempItem))
        if (tempGroupIdx === -1) {
          tempQuesData.push({ id: that.getGroupId(tempItem), name: that.setGroupName(that.getGroupId(tempItem)), data: [] })
          tempGroupIdx = tempQuesData.length - 1
        }

        // 向分类加入数据
        const nowGroupData = tempQuesData[tempGroupIdx].data
        if (that.getParentId(tempItem)) {
          // 子问题（序号比主问题大,必定会有主问题）
          const tempQuesIdx = nowGroupData.findIndex(i => that.getParentId(tempItem) === i.id)

          if (tempQuesIdx === -1) {
            tempQuesData[tempGroupIdx].data.push({ ...tempItem, error: '异常' })
          } else {
            const tempParentData = nowGroupData[tempQuesIdx]

            const tempIsUse = that.setSubQuesUse(tempParentData.sort, tempItem.sort, that.getQuesType(tempParentData), tempParentData.option)
            tempQuesData[tempGroupIdx].data[tempQuesIdx].subData.push({ ...tempItem, isUse: tempIsUse })
          }
        } else {
          // 主问题
          tempQuesData[tempGroupIdx].data.push({ ...tempItem, newSort: nowGroupData.length + 1, subData: [] })
        }
      }

      that.quesData = tempQuesData
    },
    // 获取选项比例
    getOptionRatio: function (id, key) {
      const that = this

      const tempRatio = that.sessionQuesOptionData[id] ? that.sessionQuesOptionData[id][key] / that.sessionQuesOptionData[id]['totalQues'] : 0

      return tempRatio ? resetSpecNum(tempRatio).toFixed(2) + '%' : 0
    },
    // 获取选项统计数据
    getOptionTotal: function (id, key) {
      const that = this

      const tempRatio = that.sessionQuesOptionData[id] ? that.sessionQuesOptionData[id][key] : 0

      return tempRatio || 0
    },
    // 获取问题类型
    getQuesTypeName: function (val) {
      let tempVal = ''

      switch (val) {
        case 'multiple':
          tempVal = '多选'
          break
        case 'single':
          tempVal = '单选'
          break
        case 'fill-in':
          tempVal = '填空'
          break
        case 'multiple-fill-in':
          tempVal = '多选-填空'
          break
        case 'single-city':
          tempVal = '单选-城市'
          break
        default:
          tempVal = '错误'
          break
      }

      return tempVal
    },
    getApiData: function (url) {
      const that = this
      return new Promise((resolve, reject) => {
        _Ajax({ baseUrl: that.baseUrl, method: 'get', url: url, clearCancelSource: true }, (res) => { resolve(res.data.data) }, reject)
      })
    },
    getGroupId: function (d) { return d && d.groupId ? d.groupId : 'other' },
    setGroupName: function (v) {
      const tempData = this.groupData.filter(i => i.id === v)[0]
      if (tempData) return tempData.name
      else return '无分组'
    },
    // 性别单独统计（旧版为填空，后改为单选）
    isGenderTotal: function (data) {
      const that = this
      const tempQuesId = that.genderQuesInfo ? that.genderQuesInfo.id : null
      const genderMan = 1
      const genderWoMan = 2
      let key = null
      if (tempQuesId === data.questionId) {
        if (data.content && data.content.indexOf('男') > -1) key = genderMan
        if (data.content && data.content.indexOf('女') > -1) key = genderWoMan
      }

      return key
    },
    // 城市单独统计（旧版为填空，后改为单选）
    isCityTotal: function (data) {
      const that = this
      const tempQuesId = that.cityQuesInfo ? that.cityQuesInfo.id : null
      const tempVal = data.content
      let key = null
      if (tempQuesId === data.questionId) {
        const isCityCode = tempVal === Number(tempVal)
        if (isCityCode) {
          key = that.getCityKey(tempVal)
        } else {
          const tempCityData = that.initalCityData
          const isExistCity = tempCityData.filter(i => tempVal && (tempVal.indexOf(i.name) > -1 || tempVal.indexOf(i.pinyinFull) > -1))
          key = isExistCity && isExistCity.length ? that.getCityKey(isExistCity[0].code) : '未识别：' + tempVal
        }
      }

      return key
    },
    getIsUse: function (d) { return this.getParentId(d) && d.isUse },
    /**
     * 是否使用子问题
     * @param {*} a // 主问题序号
     * @param {*} b // 子问题序号
     * @param {*} t // 主问题题型
     * @param {*} o // 主问题选项
     * @returns Boolean
     */
    setSubQuesUse: function (a, b, t, o) {
      const that = this
      /**
       * 子问题序号设计
       *    有归属选项
       *      格式：100000 + [主问题序号] + [有无选项0/1] + [选项序号]
       *      例：“第1个主问题第1个选项”的子问题序号：10000011001（100000 + 1 + 1 + 001）
       *          “第15个主问题第4个选项”的子问题序号：100000151004（100000 + 15 + 1 + 004）
       *    无归属选项
       *      格式：100000 + [主问题序号] + [有无选项0/1] + 000
       *      例：“第8个主问题”的子问题序号：10000080000（100000 + 8 + 0 + 000）
       *          “第11个主问题”的子问题序号：100000110000（100000 + 11 + 0 + 000）
       */
      // 仅适用于单选
      if (!that.isSingle(t)) return true

      const baseOrder = 10 * 10000
      const isOption = (a) => a ? 1 : 0
      const setOption = (a) => a.toString().padStart(3, '0')

      b = b + '' // 使用字符
      const noneOption = baseOrder + '' + a + '' + isOption(false)
      const useOption = baseOrder + '' + a + '' + isOption(true) + '' + setOption(!isNaN(parseFloat(o)) && o >= 1 ? o : 0)

      return b && (b.toString().indexOf(noneOption) > -1 || b === useOption)
    },
    // 根据code获取城市名称
    getCityVal: function (v) {
      const that = this
      let tempVal = v

      if (v) {
        tempVal = that.cityData[v] ? that.cityData[v] : v
      }

      return tempVal
    },
    getQuesType: function (v) { return v ? v.type : '' },
    getParentId: function (v) { return v ? v.parentId : '' },
    isSingle: function (v) { return v === 'single' },
    isSingleCity: function (v) { return v.indexOf('城市') > -1 },
    // isSingleCity: function (v) { return v === 'single-city' },
    getCityKey: function (v) {
      return 'c-' + v
    }
  },
  mounted () {
    document.title = tempSiteName
    const that = this
    const envModule = process.env.ENV_MODULE

    that.baseUrl = envModule === 'development' ? 'https://ind.test.geetecho.com' : 'https://ind.geetecho.com'
    // that.baseUrl = envModule === 'development' ? 'http://localhost:3000' : 'https://ind.geetecho.com'

    that.getData()
  }
}
</script>

<style scoped>
.inquire {text-align: left}
.inquire_header {width: 1200px;margin: 0 auto;padding: 10px 0}
.inquire_search {text-align: right}
.inquire_category {display: flex}
.inquire_category select {width: 200px;font-size: 14px;padding: 6px 12px;margin-right: 20px}

.inquire_mian {height: 80vh;overflow: auto;margin-top: 20px}
.inquire_group {background-color: #FFF;margin: 0 auto;width: 1100px;padding: 40px 50px;border-radius: 8px}
.inquire_group_header {margin: 40px 0}
.inquire_group_header_title span {font-size: 20px;font-weight: bold}
.inquire_group_question_con + .inquire_group_question_con {margin-top: 20px}
.inquire_group_sub_question {margin-top: 16px}
.inquire_group_sub_question_con + .inquire_group_sub_question_con {margin-top: 20px}
</style>



// WEBPACK FOOTER //
// src/components/page-inquire-question/index.vue